
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"124.417","height":"157.158"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M62.209 0a12.993 12.993 0 00-12.483 9.822h-39.9A9.875 9.875 0 000 19.645v127.691a9.875 9.875 0 009.822 9.822h104.773a9.875 9.875 0 009.822-9.822V19.645a9.875 9.875 0 00-9.822-9.822h-39.9A12.993 12.993 0 0062.209 0zm0 6.548a6.5 6.5 0 016.548 6.552 3.28 3.28 0 003.274 3.274h9.822v6.548H42.564v-6.551h9.822A3.28 3.28 0 0055.66 13.1a6.5 6.5 0 016.549-6.552zM9.822 16.371h26.193v9.822a3.28 3.28 0 003.274 3.274h45.838a3.28 3.28 0 003.273-3.274v-9.822h26.193a3.217 3.217 0 013.274 3.274v127.691a3.217 3.217 0 01-3.274 3.274H9.822a3.217 3.217 0 01-3.274-3.274V19.645a3.217 3.217 0 013.274-3.274z","fill":"#fcffff"}})])
          )
        }
      }
    